<template>
  <qx-card title="地图信息">
    <MapTrack v-show="resultData.items && resultData.items.length !== 0" ref="trackMap" />
    <p v-show="!resultData.items || resultData.items.length === 0" class="textCenter">暂无数据</p>
  </qx-card>
</template>

<script>
import MapTrack from 'components/mapTrack';
import {
  trackQuery,
} from 'api/operate';
export default {
  components: {
    MapTrack,
  },
  data () {
    return {
      searchBoxData: {},
      resultData: {},
    };
  },
  methods: {
    saveSearchBoxData (searchBoxData) {
      if (!searchBoxData.equipment) {
        this.$message.error('请输入车牌号码');
        return;
      }
      this.searchBoxData = searchBoxData;
      this.getData();
    },
    async getData () {
      this.loading = true;
      const data = await trackQuery(this.searchBoxData);
      data.items.forEach((item) => {
        item.eand = item.longitude;
        item.nand = item.latitude;
      });
      this.resultData = data;
      this.$nextTick(() => {
        this.$refs.trackMap.setTrack(data);
        this.loading = false;
      });
    },
  },
};
</script>

<style>

</style>
